<template>
  <v-alert
    dark
    v-model="isVisible"
    :type="type"
    transition="scale-transition"
  >
    <v-row align="center">
      <v-col class="grow" v-html="message">            
      </v-col>
      <v-col class="shrink">
        <ps-icon icon="close" :click="closeAlert"/>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
  export default {
    name: "PsAlert",
    props: {
      value: {
        type: Boolean,
        default: true
      },
      message: {
        type: String,
        required: true
      },
      alert: {
        type: Boolean, // if it exists = show
        default: false
      },
      // success, info, warning or error
      type: {
        type: String,
        default: "info"
      },
      // if it exists = true
      dismissible: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      isVisible: {
        get () {
          if (this.value === false) {
            if (!this.isMounted) return this.value;
          }
          return this.value;
        },
        set (value) {
          this.$emit("input", value);
        }
      }
    },
    methods: {
      closeAlert() {
        this.isVisible = false;
      }
    }
  };
</script>
